
export  function getRandomNumber(title){
    return (title.charAt(0) + Math.floor((Math.random() * 1000000000000000000) + 100000)) 
}
 